/**
 * @file 公共模块,包含Header、Footer、反馈等公共部分
 * @author fengfaxia(fengfaxia@baidu.com))
 *  Copyright (c) 2018-09-26 Baidu
 */
import React, {PureComponent} from 'react';
import {Layout} from 'antd';
import {Route, Switch, Redirect} from 'react-router-dom';
import Header from '../Header/index';
import Feedback from '../Feedback/index';
import Footer from '../Footer/index';
import Operation from '../../container/Operation/index';
import Home from '../../container/Home/index';
import APIDoc from '../../container/APIDoc/index';
import APIDocV2 from '../../container/APIDoc/APIDocV2';
import Report from '../../container/Report/index';
import UserInfo from '../../container/UserInfo/index';
import FAQ from '../../container/FAQ/index';
import Product from '../../container/Product';
import Price from '../../container/Price';
import SLA from '../../container/SLA';
import Service from '../../container/Service';
import GuideReport from '../../container/GuideReport';
import Senior from '../../container/Senior/seniorNew';

export default class Wrapper extends PureComponent {
    render() {
        return (
            <Layout>
                <Header />
                <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/console/operation" component={Operation} />
                <Route path="/console/report" component={Report} />
                <Route path="/console/userinfo" component={UserInfo} />
                <Route path="/console/apidoc/v3" component={APIDoc} />
                {/* <Route path="/console/apidoc/v2" component={APIDocV2} /> */}
                <Route path="/console/faq" component={FAQ} />
                <Route path="/console/product" component={Product} />
                <Route path="/console/price" component={Price} />
                <Route path="/console/sla" component={SLA} />
                <Route path="/console/service" component={Service} />
                {/* <Route path="/console/guide/report" component={GuideReport} /> */}
                <Route path="/console/advanced_report" component={Senior} />
                <Redirect from='/console/apidoc' to='/console/apidoc/v3' />
                </Switch>
                <Footer />
                <Feedback />
            </Layout>
        );
    }
}